import booking, { BookingCreateRequest, BookingCreateResponse } from '@api/booking'
import { makeMutation } from '@lib/mutation'

export const useCreateBooking = makeMutation<BookingCreateRequest | null, BookingCreateResponse>({
  key: 'bookingCreate',
  loader: async body => await booking.create({ params: {}, body: body as BookingCreateRequest }),
})
